import { render } from "./AlartModal.vue?vue&type=template&id=3ef96810&scoped=true"
import script from "./AlartModal.vue?vue&type=script&lang=js"
export * from "./AlartModal.vue?vue&type=script&lang=js"

import "./AlartModal.vue?vue&type=style&index=0&id=3ef96810&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef96810"]])

export default __exports__